import router from '../../router'
import {
  MEDICINE_INFORMATION_SEARCH, MEDICINE_INFORMATION_SEARCH_SUCCESS, MEDICINE_INFORMATION_SEARCH_FAILURE,
  MEDICINE_INFORMATION_CREATE, MEDICINE_INFORMATION_CREATE_SUCCESS, MEDICINE_INFORMATION_CREATE_FAILURE, MEDICINE_INFORMATION_UPLOAD_START,
  MEDICINE_INFORMATION_PDF, MEDICINE_INFORMATION_PDF_SUCCESS, MEDICINE_INFORMATION_PDF_FAILURE,
  MEDICINE_INFORMATION_UPDATE, MEDICINE_INFORMATION_UPDATE_SUCCESS, MEDICINE_INFORMATION_UPDATE_FAILURE,
  MEDICINE_INFORMATION_DELETE, MEDICINE_INFORMATION_DELETE_SUCCESS, MEDICINE_INFORMATION_DELETE_FAILURE,
  CLEAR_MEDICINE_INFORMATION_SEARCH_PARAMS
} from './mutation-types'

export default {
  state: {
    medicineInformation: null,
    medicineInformationCurrentPage: 1,
    medicineInformationNextPage: null,
    patient: null,
    uploader: {
      total: 0,
      current: 0,
      errors: []
    },
    medicineInformationPDF: null,
    searchParams: null
  },
  getters: {
    medicineInformation: state => {
      return state.medicineInformation
    },
    medicineInformationCurrentPage: state => {
      return state.medicineInformationCurrentPage
    },
    medicineInformationNextPage: state => {
      return state.medicineInformationNextPage
    },
    medicineInformationPatient: state => {
      return state.patient
    },
    uploadCounter: state => {
      var counter = state.uploader.current + '/' + state.uploader.total
      if (state.uploader.total === 0) {
        return ''
      } else {
        return counter + '件のアップロードが完了しました。'
      }
    },
    uploadErrors: state => {
      return state.uploader.errors
    },
    medicineInformationPDF: state => {
      return state.medicineInformationPDF
    },
    medicineInformationSearchParams: state => {
      return state.searchParams
    }
  },
  actions: {
    [MEDICINE_INFORMATION_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = ''
      var callback = () => {}
      if (params.patientId) {
        url = '/patients/' + params.patientId + '/medicine_information'
      } else {
        url = '/manage/medicine_information'
      }

      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
      }
      if (params && params.url && !params.clear) {
        url = params.url
      }
      if (params && params.clear) {
        state.medicineInformation = null
        state.medicineInformationCurrentPage = 1
        state.medicineInformationNextPage = null
      }

      state.searchParmas = params.data
      dispatch('apiGet', {url: url, data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_INFORMATION_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MEDICINE_INFORMATION_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_INFORMATION_UPLOAD_START] ({dispatch, state, commit}, params = null) {
      state.uploader.total = params.totalCount
      state.uploader.current = 0
      state.uploader.errors = []
    },
    [MEDICINE_INFORMATION_CREATE] ({dispatch, state, commit}, params = null) {
      var url = '/manage/medicine_information'

      dispatch('apiPost', {url: url, data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_INFORMATION_CREATE_FAILURE, res.data)
          } else {
            commit(MEDICINE_INFORMATION_CREATE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_INFORMATION_UPDATE] ({dispatch, state, commit}, params = null) {
      var url = '/manage/medicine_information/' + params.medicineInformationId

      dispatch('apiPatch', {url: url, data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_INFORMATION_UPDATE_FAILURE, res.data)
          } else {
            commit(MEDICINE_INFORMATION_UPDATE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_INFORMATION_PDF] ({dispatch, state, commit}, params = null) {
      return new Promise((resolve, reject) => {
        var url = params.url

        dispatch('apiBlobDownload', {url: url})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(MEDICINE_INFORMATION_PDF_FAILURE, res.data)
              reject()
            } else {
              commit(MEDICINE_INFORMATION_PDF_SUCCESS, res.data)
              resolve()
            }
          }
        })
      })
    },
    [MEDICINE_INFORMATION_DELETE] ({dispatch, state, commit}, params = null) {
      var url = '/manage/medicine_information/' + params.medicineInformationId

      dispatch('apiDelete', {url: url})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_INFORMATION_DELETE_FAILURE, res.data)
          } else {
            commit(MEDICINE_INFORMATION_DELETE_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CLEAR_MEDICINE_INFORMATION_SEARCH_PARAMS] ({state}) {
      state.searchParams = null
    }
  },
  mutations: {
    [MEDICINE_INFORMATION_SEARCH_FAILURE] (state, data) {
      console.log('MEDICINE_INFORMATION_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [MEDICINE_INFORMATION_SEARCH_SUCCESS] (state, params) {
      console.log('MEDICINE_INFORMATION_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.medicineInformation = state.medicineInformation.concat(data.data)
        state.medicineInformationCurrentPage = data.meta['current-page']
      } else {
        state.medicineInformation = data.data
        state.medicineInformationCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.medicineInformationNextPage = data.links['next']
      }
      if (params.callback) {
        params.callback()
      }
    },
    [MEDICINE_INFORMATION_CREATE_FAILURE] (state, data) {
      console.log('MEDICINE_INFORMATION_CREATE_FAILURE')
      state.uploader.errors.push(data.error)
    },
    [MEDICINE_INFORMATION_CREATE_SUCCESS] (state, data) {
      console.log('MEDICINE_INFORMATION_CREATE_SUCCESS')
      state.uploader.current += 1
    },
    [MEDICINE_INFORMATION_UPDATE_FAILURE] (state, data) {
      console.log('MEDICINE_INFORMATION_UPDATE_FAILURE')
      state.uploader.errors.push(data.error)
    },
    [MEDICINE_INFORMATION_UPDATE_SUCCESS] (state, data) {
      console.log('MEDICINE_INFORMATION_UPDATE_SUCCESS')
      router.push({name: 'manageMedicine'})
    },
    [MEDICINE_INFORMATION_PDF_FAILURE] (state, data) {
      console.log('MEDICINE_INFORMATION_PDF_FAILURE')
    },
    [MEDICINE_INFORMATION_PDF_SUCCESS] (state, data) {
      console.log('MEDICINE_INFORMATION_PDF_SUCCESS')
      state.medicineInformationPDF = data
    },
    [MEDICINE_INFORMATION_DELETE_FAILURE] (state, data) {
      console.log('MEDICINE_INFORMATION_DELETE_FAILURE')
      window.alert(data.error)
    },
    [MEDICINE_INFORMATION_DELETE_SUCCESS] (state, data) {
      console.log('MEDICINE_INFORMATION_DELETE_SUCCESS')
      for (var i = 0; i < state.medicineInformation.length; i++) {
        console.log('state.medicineInformation[i].id:' + state.medicineInformation[i].id)
        if (state.medicineInformation[i].id === data.data.attributes['medinfo-pdf-id']) {
          state.medicineInformation.splice(i, 1)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/medicine-information.js